import React from "react";
import moment from "moment";
import { CampoData } from "../../components";
import { CDataPrimaryAnalyser } from "../../form/DigitalProductAnalyser/PrimaryAnalyser";

interface ILoanSimulationProps {
    FormData: CDataPrimaryAnalyser;
    TotalEmploymentLength: any;
}

const durationValues = [12, 24, 36, 48, 60, 72, 84, 96, 108, 120];

export const LoanSimulation: React.FC<ILoanSimulationProps> = ({ FormData, TotalEmploymentLength }) => {
    const { DateOfBirth, Duration, EffectiveDate, EmploymentDate } = { ...FormData };
    let initialAge = moment.duration(moment(EffectiveDate).diff(DateOfBirth));

    return (
        <>
            <div className="form-group special-group kt-form login-form__group row">
                <div className="col-lg-2">
                    <label>Data Decorrenza</label>
                    <div className="form-control">
                        <CampoData ValoreInArrivo={false} Name="EffectiveDate" Id="EffectiveDate" Valore={EffectiveDate} OnChange={() => {}} Disabilitato />
                    </div>
                </div>
                <div className="col-lg-2">
                    <label>Data di Nascita</label>
                    <div className="form-control">
                        <CampoData ValoreInArrivo={false} Name="DateOfBirth" Id="DateOfBirth" Valore={DateOfBirth} OnChange={() => {}} Disabilitato />
                    </div>
                </div>
                <div className="col-lg-2">
                    <label>Data Assunzione</label>
                    <div className="form-control">
                        <CampoData ValoreInArrivo={false} Name="EmploymentDate" Id="EmploymentDate" Valore={EmploymentDate} OnChange={() => {}} Disabilitato />
                    </div>
                </div>

                <div className="col-lg-2 ">
                    <label>Età alla data dec. Polizza</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <input type="text" className="form-control kt-input" value={`${initialAge.years()} - ${initialAge.months()} - ${initialAge.days()}`} readOnly />
                        <span className="form-text text-muted">aa-mm-gg</span>
                    </div>
                </div>
                <div className="col-lg-2">
                    <label className="text-nowrap">Anzianità calcolata alla data di dec. Polizza</label>
                    <div className="kt-input-icon kt-input-icon--right">
                        <input
                            type="text"
                            className="form-control kt-input"
                            value={`${TotalEmploymentLength.years()} - ${TotalEmploymentLength.months()} - ${TotalEmploymentLength.days()}`}
                            readOnly
                        />
                        <span className="form-text text-muted">aa-mm-gg</span>
                    </div>
                </div>
            </div>

            <div className="form-group kt-form login-form__group row">
                <div className="col-lg-10">
                    <table className="table table-hover">
                        <thead>
                            <tr>
                                <th>Mesi durata</th>
                                <th>
                                    Scadenza annuali
                                    <br />
                                    per ogni fascia di durata
                                </th>
                                <th>
                                    Età alle varie scadenze
                                    <br />
                                    (aa-mm-gg)
                                </th>
                                <th>
                                    Anzianità calcolata
                                    <br />
                                    alle varie scadenze
                                    <br />
                                    (aa-mm-gg)
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {durationValues.map(value => {
                                initialAge.add(1, "years");
                                TotalEmploymentLength.add(1, "years");

                                return (
                                    <tr className={value > parseInt(Duration) ? "text-muted table-secondary" : ""} key={value}>
                                        <td>{value}</td>
                                        <td>{moment(EffectiveDate).add(value, "months").format("DD/MM/YYYY")}</td>
                                        <td>{`${initialAge.years()} - ${initialAge.months()} - ${initialAge.days()}`}</td>
                                        <td>{`${TotalEmploymentLength.years()} - ${TotalEmploymentLength.months()} - ${TotalEmploymentLength.days()}`}</td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    );
};



// WEBPACK FOOTER //
// ./src/components/DigitalProductAnalyser/LoanSimulation.tsx